define(
    'views/admin_index.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/chatovod-block.html',
        'text!templates/twitter-block.html'

    ],
    function(Loader, Config, Helper, Sandbox, chatBlockTemplate, twitterBlockTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AdminIndexView = Loader.Backbone.View.extend(
            {

                routes: {
                    "/admin_index.php$": "hideWebtalkPosition chatBlock twitterBlock"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });

                    this.model.get('forum').on('change:twits', function(){
                        _this.twitterBlock();
                    });

                },

                render: function()
                {
                    return this;
                },

                hideWebtalkPosition: function()
                {
                    $("li:contains('Занимает')")
                        .hide();
                },

                chatBlock: function()
                {
                    if (this.model.get('forum').get('baseDomain') == '0pk.ru')
                    var compiledTemplate = _.template(
                        chatBlockTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    $("#pun-admain1:first .adcontainer").append(compiledTemplate);
                },

                twitterBlock: function()
                {
                    if (!Helper.isValidRoute('/admin_index.php$')) return;
                    $('#twitterBlock').remove();

                    var compiledTemplate = _.template(
                        twitterBlockTemplate,
                        {
                            model: this.model.toJSON(),
                            twits: this.model.get('forum').get('twits')
                        }
                    );

                    $("#pun-admain1:first .adcontainer").append(compiledTemplate);
                }
            });

        return {
            initialize: function(model)
            {
                return new AdminIndexView({
                    el: $("#pun-admain1"),
                    model: model
                })
            }
        }
    }
);
